import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import validateFormInfoUser from "../../../validtions/forms/user-info";
import httpService from "../../../services/httpServices/httpServices";
import formMessages from "../../../messages/user";
import userAction from "../../../store/actions/userAction";
import EmailUser from "./EmailUser";
import MobileUser from "./MobileUser";
import helperSpinner from "../../../helpers/spinner";
import TitleBar from "../../partials/content/TitleBar";
import AllSiteUserAdvertiser from "./AllSiteUserAdvertiser";
import SelectDropDown from "../../partials/content/SelectDropDown";
import EditPassword from "./EditPassword";

const typeUserString = {
  REAL: 1,
  LEGAL: 2,
};

function InfoUser({ enterUserFirstNameLastName, permissionsUser }) {
  const initObjectInfoUser = {
    firstname: "",
    lastname: "",
    category_id: 0,
    category_name: "",
    phone: "",

    national_code: "",
    identity_number: "",

    identity_national: "",
    economic_number: "",
    register_number: "",

    state: "",
    city: "",
    town: "",
    postal_code: "",
    description: "",
    reason_ban: "",
    email: "",
    mobile: "",
  };

  const [message, setMessage] = useState();
  const [typeUser, setTypeUser] = useState(typeUserString.REAL);

  const [categoriesSitesPublishers, setCategoriesSitesPublishers] = useState(
    []
  );
  const [userInfo, setUserInfo] = useState();

  const popover = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      <span style={{ fontFamily: "IRANSansWeb" }}>
        <span>در این</span>
        <span>
          <Link
            className="px-1 d-inline-block"
            target="_blank"
            to="/publishers/list-category-site-publisher"
          >
            صفحه
          </Link>
        </span>
        <span>میتوانید تمامی دسته های صنفی را مشاهده کنید.</span>
      </span>
    </Tooltip>
  );

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span className="text-dark">{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getCategoriesSitesPublishers();
  }, []);

  useEffect(() => {
    if (!categoriesSitesPublishers.length) {
      return;
    }
    getUserInfo();
  }, [categoriesSitesPublishers]);

  const getUserInfo = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let userInfo = await getInitInfoUser();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!userInfo) {
      setMessage({
        type_class: "alert alert-info",
        text: "برای استفاده از پنل تبلیغات ابتدا اطلاعات خود را وارد کنید.",
        class_icon: "fa fa-info",
      });
      return;
    }

    setTypeUser(typeUserString[userInfo.type.toUpperCase()]);

    let categoryUser;
    if (userInfo.category) {
      categoryUser = categoriesSitesPublishers.filter(
        (category) => category.name == userInfo.category
      );

      categoryUser = {
        category_id: categoryUser[0].id,
        category_name: userInfo.category,
      };
    }

    setUserInfo({
      ...categoryUser,
      ...userInfo,
    });

    if (permissionsUser.includes("permission-user-ban")) {
      setMessage({
        type_class: "alert alert-warning ",
        text: (
          <>
            <span className="text-danger"> پیام پشتیان : </span>
            <span>{userInfo.reason_ban}</span>
          </>
        ),
        class_icon: "fa fa-info text-danger",
      });
    }
  };

  const getCategoriesSitesPublishers = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let categoriesSitesPublishers =
      await sendRequestCategoriesSitesPublishers();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!categoriesSitesPublishers) {
      return;
    }
    setCategoriesSitesPublishers(categoriesSitesPublishers);
  };

  const sendRequestCategoriesSitesPublishers = async () => {
    const headersRequest = getHeaderRequest();
    let categoriesSitesPublishers;
    try {
      categoriesSitesPublishers = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/all-category-site-publishers-users",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoriesSitesPublishers.data.data;
  };

  const sendInfoUser = async (e) => {
    e.preventDefault();
    const info = getDataForm();

    if (validateFormInfoUser.validateFormInfoUser(info) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormInfoUser.validateFormInfoUser(info),
        class_icon: "fa fa-exclamation-triangle",
      });
      const element = document.getElementById("fill-info-user");
      element.scrollIntoView();
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestEnterUserData = await sendRequestEnterUserData(info);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestEnterUserData) {
      const element = document.getElementById("fill-info-user");
      element.scrollIntoView();
      return;
    }
    const element = document.getElementById("fill-info-user");
    element.scrollIntoView();
    setMessage({
      type_class: "alert alert-success text-dark",
      text: "اطلاعات شما با موفقیت ذخیره شد و به زودی توسط تیم پشتیبانی هایلایت بررسی و تایید میشود.",
      class_icon: "fa fa-check-circle text-dark",
    });
  };

  const sendRequestEnterUserData = async (info) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/fill-info",
        info,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
    return true;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getDataForm = () => {
    let dataUserType = {};
    if (typeUser == typeUserString.REAL) {
      dataUserType = {
        lastname: document.getElementById("lastname").value,
        national_code: document.getElementById("national-code").value,
        identity_number: document.getElementById("identity-number").value,
      };
    } else if (typeUser == typeUserString.LEGAL) {
      dataUserType = {
        identity_national: document.getElementById("identity-national").value,
        economic_number: document.getElementById("economic-number").value,
        register_number: document.getElementById("register-number").value,
      };
    }

    let userTypeString;
    Object.keys(typeUserString).forEach((key) => {
      if (typeUser == typeUserString[key]) {
        userTypeString = key;
      }
    });

    return {
      firstname: document.getElementById("firstname").value,
      category_id: userInfo.category_id + "",
      user_type: userTypeString.toLowerCase(),
      ...dataUserType,
      phone: document.getElementById("phone").value,
      state: document.getElementById("state").value,
      city: document.getElementById("city").value,
      town: document.getElementById("town").value,
      postal_code: document.getElementById("postal-code").value,
      address: document.getElementById("address").value,
      description: document.getElementById("description").value,
    };
  };

  const getInitInfoUser = async () => {
    let usersInfo;
    const headersRequest = getHeaderRequest();
    try {
      usersInfo = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/info-user/",
        headersRequest
      );
    } catch (error) {
      return false;
    }

    return usersInfo.data.data;
  };

  const checkUserFillInfo = (userInfo) => {
    if (!userInfo.hasOwnProperty("firstname")) {
      return false;
    }
    if (!userInfo.hasOwnProperty("category")) {
      return false;
    }
    return true;
  };

  const setItemHandler = (newItemSelected) => {
    setUserInfo((prevSate) => {
      return {
        ...prevSate,
        category_id: newItemSelected.value + "",
        category_name: newItemSelected.label,
      };
    });
  };

  const showSelectCategorySitePublisher = () => {
    const categoriesSitesPublishersForDropDown = categoriesSitesPublishers.map(
      (category) => {
        return { value: category.id, label: category.name };
      }
    );
    let itemSelected;

    if (userInfo.category_name) {
      itemSelected = categoriesSitesPublishers.filter(
        (category) => category.id == userInfo.category_id
      );

      itemSelected = {
        label: itemSelected[0].name,
        value: itemSelected[0].id,
      };
    }

    return (
      <SelectDropDown
        data={categoriesSitesPublishersForDropDown}
        itemSelected={itemSelected}
        setItemHandler={setItemHandler}
      />
    );
  };

  return (
    <>
      <Sidebar activeItem="fill-info-user" />

      <div className="content-wrapper">
        <div className="container-fluid p-0">
          <div className="row m-0">
            <div className="position-relative w-100 title-page-container">
              <div
                className="position-absolute border border-1 border-dark py-2 px-3 title-page"
                style={{ left: "25%" }}
              >
                تایید شماره همراه
              </div>
              <div
                className="position-absolute border border-1 border-dark py-2 px-3 title-page"
                style={{ left: "75%" }}
              >
                تایید ایمیل
              </div>
              <div className="hr-title-page"></div>
            </div>
          </div>
        </div>
        {userInfo && (
          <>
            <div className="container-fluid pt-5">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  {userInfo.email != "" ? (
                    <EmailUser email={userInfo.email} />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  {userInfo.mobile != "" ? (
                    <MobileUser mobile={userInfo.mobile} />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>

            <EditPassword />

            {permissionsUser.includes("add-advertise") ? (
              <AllSiteUserAdvertiser />
            ) : (
              <></>
            )}

            <div className="container-fluid pt-3">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-lg-12 p-0">
                  <TitleBar title="اطلاعات کاربری" />

                  <section className="content pt-5">
                    <div className="card">
                      <div className="card-body" id="fill-info-user">
                        <div className="alert alert-warning ">
                          <p>
                            <i className="fa fa-info pl-2"></i>
                            توجه داشته باشید :{" "}
                          </p>
                          <ul className="pr-3">
                            <li>
                              <p>
                                لطفا توجه داشته باشید که با تغییر اطلاعات شما ,
                                کمپین های قبلی شما به حالت غیر فعال می رود و نقش
                                شما به حالت بررسی نشده تبدیل میشود تا توسط تیم
                                هایلایت اطلاعات شما تایید شود.
                              </p>
                            </li>

                            {!checkUserFillInfo(userInfo) ? (
                              <li>
                                <p>
                                  اطلاعات شما کامل وارد نشده لطفا نام و نام
                                  خانوداکی و دسته صنفی خود را وارد کنید.
                                </p>
                              </li>
                            ) : (
                              <></>
                            )}
                          </ul>
                        </div>
                        {messageTag}
                        <form
                          onSubmit={sendInfoUser}
                          className="d-flex flex-column"
                        >
                          <div className="form-group ">
                            <label>نوع کاربر</label>
                            <span class="text-danger">*</span>
                          </div>
                          <div className="d-flex flex-column flex-md-row">
                            <div className="form-group d-flex">
                              <div className="form-check pl-2 ">
                                <input
                                  className="form-check-input hover"
                                  type="radio"
                                  name="type-user"
                                  id="real-person"
                                  checked={typeUser === typeUserString.REAL}
                                  onChange={(e) => {
                                    setTypeUser(typeUserString.REAL);
                                  }}
                                />
                                <label
                                  className="form-check-label hover"
                                  for="real-person"
                                >
                                  شخص حقیقی
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input hover"
                                  type="radio"
                                  name="type-user"
                                  id="legal-person"
                                  checked={typeUser === typeUserString.LEGAL}
                                  onChange={(e) => {
                                    setTypeUser(typeUserString.LEGAL);
                                  }}
                                />
                                <label
                                  className="form-check-label hover"
                                  for="legal-person"
                                >
                                  شخص حقوقی
                                </label>
                              </div>
                            </div>
                          </div>
                          <div>
                            <hr />
                          </div>
                          <div className="d-flex flex-column flex-md-row">
                            {typeUser == typeUserString.REAL ? (
                              <>
                                {" "}
                                <div className="form-group ">
                                  <label>
                                    نام
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="firstname"
                                    placeholder="نام"
                                    defaultValue={userInfo.firstname}
                                    required
                                  />
                                </div>
                                <div className="form-group">
                                  <label>نام خانوادگی</label>
                                  <span className="text-danger">*</span>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="lastname"
                                    placeholder="نام خانوادگی"
                                    required
                                    defaultValue={userInfo.lastname}
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="form-group">
                                  <label>نام شخص حقوقی</label>
                                  <span className="text-danger">*</span>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="firstname"
                                    placeholder="نام شخص حقوقی"
                                    required
                                    defaultValue={userInfo.firstname}
                                  />
                                </div>
                              </>
                            )}

                            <div className="form-group ">
                              <label>حوزه فعالیت (دسته صنفی)</label>
                              <span className="text-danger pl-2">*</span>

                              <OverlayTrigger
                                trigger="click"
                                rootClose
                                placement="top"
                                overlay={popover}
                              >
                                <span className="hover bg-warning rounded-circle py-1 px-3 ">
                                  <i className="fa fa-info"></i>
                                </span>
                              </OverlayTrigger>
                              {showSelectCategorySitePublisher()}
                            </div>
                          </div>
                          <div>
                            <hr />
                          </div>
                          {typeUser == typeUserString.REAL ? (
                            <>
                              <div className="d-flex flex-column flex-md-row">
                                <div className="form-group">
                                  <label>شماره تلفن ثابت</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="phone"
                                    placeholder="شماره تلفن ثابت"
                                    defaultValue={userInfo.phone}
                                  />
                                </div>

                                <div className="form-group">
                                  <label>کد ملی</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="national-code"
                                    placeholder="کد ملی"
                                    defaultValue={userInfo.national_code}
                                  />
                                </div>

                                <div className="form-group">
                                  <label>شماره شناسنامه</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="identity-number"
                                    placeholder="شماره شناسنامه"
                                    defaultValue={userInfo.identity_number}
                                  />
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          {typeUser == typeUserString.LEGAL ? (
                            <>
                              <div className="d-flex flex-column flex-md-row">
                                <div className="form-group">
                                  <label>شماره تلفن ثابت</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="phone"
                                    placeholder="شماره تلفن ثابت"
                                    defaultValue={userInfo.phone}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>شناسه ملی</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="identity-national"
                                    placeholder="شناسه ملی"
                                    defaultValue={userInfo.identity_national}
                                  />
                                </div>

                                <div className="form-group">
                                  <label>شماره اقتصادی</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="economic-number"
                                    placeholder="شماره اقتصادی"
                                    defaultValue={userInfo.economic_number}
                                  />
                                </div>

                                <div className="form-group">
                                  <label>شماره ثبت</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="register-number"
                                    placeholder="شماره ثبت"
                                    defaultValue={userInfo.register_number}
                                  />
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          <div className="d-flex flex-column flex-md-row">
                            <div className="form-group">
                              <label>استان</label>
                              <input
                                type="text"
                                id="state"
                                className="form-control"
                                placeholder="استان"
                                defaultValue={userInfo.state}
                              />
                            </div>
                            <div className="form-group">
                              <label>شهر</label>
                              <input
                                type="text"
                                id="city"
                                className="form-control"
                                placeholder="شهر"
                                defaultValue={userInfo.city}
                              />
                            </div>
                            <div className="form-group">
                              <label>شهرستان </label>
                              <input
                                type="text"
                                id="town"
                                className="form-control"
                                placeholder="شهرستان "
                                defaultValue={userInfo.town}
                              />
                            </div>

                            <div className="form-group">
                              <label>کد پستی 10 رقمی </label>
                              <input
                                type="number"
                                id="postal-code"
                                className="form-control"
                                placeholder="کد پستی "
                                defaultValue={userInfo.postal_code}
                              />
                            </div>
                          </div>
                          <div className="d-flex flex-column flex-md-row">
                            <div className="form-group description-user-input">
                              <label>آدرس دقیق</label>
                              <input
                                type="text"
                                id="address"
                                className="form-control"
                                placeholder="آدرس"
                                defaultValue={userInfo.address}
                              />
                            </div>
                          </div>
                          <div className="d-flex flex-column flex-md-row">
                            <div className="form-group description-user-input">
                              <label>توضیحات</label>
                              <textarea
                                type="text"
                                id="description"
                                className="form-control"
                                placeholder="توضیحات"
                                rows="8"
                                defaultValue={
                                  userInfo.description
                                    ? userInfo.description
                                    : ""
                                }
                              ></textarea>
                            </div>
                          </div>
                          <div className="d-flex flex-column flex-md-row">
                            <div className="text-center w-100">
                              <button type="submit" className="btn btn-success">
                                ارسال اطلاعات
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    enterUserFirstNameLastName: (action) => {
      dispatch({
        type: userAction.ENTER_USER_FIRSTNAME_LASTNAME,
        payload: action,
      });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    permissionsUser: state.main.permissionsUser,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoUser);
